(function () {
  "use strict";

  var cfg = window.__SVZ_VERIFY_CONFIG__ || {};
  var input = document.querySelector("[data-verify-input]");
  var hint = document.querySelector("[data-verify-hint]");
  var hintValue = document.querySelector("[data-verify-hint-value]");
  var copyBtn = document.querySelector("[data-verify-copy]");
  var cta = document.querySelector("[data-verify-cta]");
  var mine = document.querySelector("[data-verify-mine]");
  var mineList = document.querySelector("[data-verify-mine-list]");

  function updateHint() {
    var v = (input.value || "").trim();
    if (v) {
      hintValue.textContent = v;
      hint.hidden = false;
    } else {
      hint.hidden = true;
    }
    cta.setAttribute("href", cfg.igiUrl || "https://www.igi.org/verify-your-report/");
  }

  if (input) {
    input.addEventListener("input", updateHint);
  }

  if (copyBtn) {
    copyBtn.addEventListener("click", function () {
      var v = (input.value || "").trim();
      if (!v || !navigator.clipboard) return;
      navigator.clipboard.writeText(v).then(function () {
        var original = copyBtn.textContent;
        copyBtn.textContent = "Copied";
        setTimeout(function () { copyBtn.textContent = original; }, 1500);
      });
    });
  }

  /* Best-effort, logged-out-safe: calls the session action directly rather
   * than SvzAuth.requireSession (which redirects on failure). A logged-out
   * visitor just never sees the "Your certificates" block -- no error, no
   * redirect, no invented numbers. */
  function tryShowCertificates() {
    var token = null;
    try {
      token = window.SvzAuth && window.SvzAuth.getToken && window.SvzAuth.getToken();
    } catch (e) {
      token = null;
    }
    if (!token || !window.SvzAuth || !window.SvzAuth.api) return;

    window.SvzAuth.api(cfg, { action: "session", token })
      .then(function (session) {
        var certs = (session && session.certificates) || [];
        if (!certs.length) return;

        mineList.innerHTML = "";
        certs.forEach(function (c) {
          if (!c || !c.certificate_number) return;
          var li = document.createElement("li");
          var bits = [c.certificate_type_label, c.certificate_number, c.product_title].filter(Boolean);
          li.textContent = bits.join(" · ");
          mineList.appendChild(li);
        });

        if (mineList.children.length) {
          mine.hidden = false;
        }
      })
      .catch(function () {
        /* logged-out or session lookup failed -- leave the block hidden */
      });
  }

  tryShowCertificates();
})();
